// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgAlarmWarning = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.608 6.82A6.5 6.5 0 0 1 9.18 1.608.75.75 0 0 0 9.453.133a8 8 0 0 0-7.14 13.494L1.22 14.72a.75.75 0 0 0 1.06 1.06l1.187-1.186a7.973 7.973 0 0 0 3.08 1.273c2.171.4 4.299-.115 5.985-1.274l1.188 1.188a.75.75 0 1 0 1.06-1.061l-1.092-1.093a7.963 7.963 0 0 0 2.18-4.174.75.75 0 0 0-1.476-.273A6.5 6.5 0 1 1 1.608 6.82ZM1.78.22a.75.75 0 0 1 0 1.06l-.5.5A.75.75 0 1 1 .22.72l.5-.5a.75.75 0 0 1 1.06 0ZM8 4a.75.75 0 0 1 .75.75v2.94l2.03 2.03a.75.75 0 1 1-1.06 1.06L7.47 8.53A.75.75 0 0 1 7.25 8V4.75A.75.75 0 0 1 8 4Zm6-4a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 14 0Zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
    />
  </svg>
)

export default SvgAlarmWarning
